// function to format queries names
export function removeAccents (strAccents) {
  strAccents = strAccents.split('');
  var strAccentsOut = [];
  var strAccentsLen = strAccents.length;
  var accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
  var accentsOut = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';
  for (var y = 0; y < strAccentsLen; y++) {
    if (accents.indexOf(strAccents[y]) !== -1) {
      strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1)
    } else { strAccentsOut[y] = strAccents[y] }
  }
  strAccentsOut = strAccentsOut.join('');
  return strAccentsOut
}

// Color palettes
export var mixPalette = ['#8A2BE2', '#823eeb', '#794df2', '#6f5af9', '#6666ff', '#0096ff', '#00b9ff', '#00d5ff', '#00ece9', '#7fffd4'];
